.filter-checkbox {
  height: 100%;
  && > label {
    font-size: 14px;
  }
}
